<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30.5 35.625V30.3206C30.5001 28.9161 30.162 27.5321 29.5144 26.2858C28.8668 25.0395 27.9287 23.9673 26.7794 23.16L23.325 20.7344C23.2429 20.6767 23.1758 20.6001 23.1295 20.5111C23.0832 20.422 23.0591 20.3232 23.0591 20.2228C23.0591 20.1225 23.0832 20.0236 23.1295 19.9345C23.1758 19.8455 23.2429 19.7689 23.325 19.7113L26.7788 17.2856C27.9282 16.4784 28.8664 15.4063 29.5142 14.1599C30.1619 12.9136 30.5 11.5296 30.5 10.125V4.375M10.5 4.375V10.125C10.5 11.5296 10.8381 12.9136 11.4858 14.1599C12.1336 15.4063 13.0718 16.4784 14.2213 17.2856L17.675 19.7113C17.7571 19.7689 17.8242 19.8455 17.8705 19.9345C17.9168 20.0236 17.9409 20.1225 17.9409 20.2228C17.9409 20.3232 17.9168 20.422 17.8705 20.5111C17.8242 20.6001 17.7571 20.6767 17.675 20.7344L14.2213 23.16C13.0718 23.9672 12.1336 25.0394 11.4858 26.2857C10.8381 27.5321 10.5 28.916 10.5 30.3206V35.625"
      stroke="currentColor"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />

    <path
      d="M10.5 34.375C13 34.375 16.7244 30.87 18.615 29.375C19.1607 28.9751 19.8193 28.7586 20.4959 28.7568C21.1725 28.755 21.8322 28.968 22.38 29.365C24.2856 30.8469 28 34.375 30.5 34.375M13.0525 16.25C18.0525 14.2469 22.1775 18.5313 28.1281 16.115M17.885 20.4813C19.6794 20.9375 20.3956 23.125 20.5 23.125C20.5825 23.125 21.0419 21.01 23.0625 20.1844"
      stroke="currentColor"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />

    <path
      d="M31.75 35.625H9.25C8.90482 35.625 8.625 35.9048 8.625 36.25V38.125C8.625 38.4702 8.90482 38.75 9.25 38.75H31.75C32.0952 38.75 32.375 38.4702 32.375 38.125V36.25C32.375 35.9048 32.0952 35.625 31.75 35.625Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />

    <path
      d="M31.75 1.25H9.25C8.90482 1.25 8.625 1.52982 8.625 1.875V3.75C8.625 4.09518 8.90482 4.375 9.25 4.375H31.75C32.0952 4.375 32.375 4.09518 32.375 3.75V1.875C32.375 1.52982 32.0952 1.25 31.75 1.25Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
